export const DATA_CTA = 'data-cta';
export const DATA_TOP_ITEMS = 'data-top-items';
export const DATA_VERSION = 'data-version';
export const CONTENT_MARKETING_CLASS_NAME = 'content-marketing';
export const CONTENT_MARKETING_ITEM_CLASS_NAME = `${CONTENT_MARKETING_CLASS_NAME}-item`;
